<template>
  <div class="commonTopbar w_inner clearfix">
    <div class="bar_left l">
      <!-- <p class="gray3 ftSmall l">欢迎来到很能猜</p> -->
      <p class="gray3 ftSmall l" v-if="switchboardIdentity.switchboard_identity_name">
        欢迎<span class="yellow-txt ftSmall"
          >【{{ switchboardIdentity.switchboard_identity_name }}-{{
            switchboardIdentity.login
          }}】</span
        >
      </p>
      <p v-else class="gray3 ftSmall l">
        欢迎<span class="yellow-txt ftSmall"
          >【{{ switchboardIdentity.login }}】</span
        >
      </p>
      <!-- :href="osDomain+'/anzhuang.html'" -->
      <a class="gray3 ftSmall l download" @click="download">APP下载</a>
    </div>
    <div class="tapSystem">
      <span class="title">当前系统:</span>
      <span>
        <el-select v-model="osUrl" @change="switchSystem">
					<el-option
						v-for="item in systemList"
						:key="item.id"
						:label="item.name"
						:value="item.id"
					></el-option>
				</el-select>
      </span>
    </div>
    <!-- <div class="r">
			<div class="l" style="font-size: 14px;">当前系统：</div>
				<div class="l">
					<el-select size="mini" v-model="value" placeholder="请选择" @change="changeSystem">
						<el-option
							v-for="item in options"
							:key="item.id"
							:label="item.label"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
		</div> -->
  </div>
</template>
<script>
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  name: "Topbar",
  props: {
    msg: String,
    switchboardIdentity: {
      type: Object,
    },
  },
  data() {
		return {
			systemList: [], //获取系统列表
      osUrl: '',//
      osDomain: '',//
    };
  },
	mounted() {
		if (this.switchboardIdentity.businessSystemId) {
			this.osUrl = this.switchboardIdentity.businessSystemId
		}
    // let switchboardIdentity = localStorage.getItem('switchboardIdentity')
    // this.switchboardIdentity = JSON.parse(switchboardIdentity)
		this.getSystemList()
	},
	watch: {
		switchboardIdentity(newV,oldV) {
			if (newV && newV.businessSystemId) {
				this.osUrl = newV.businessSystemId
			}
		} 
	},
  methods: {
    // esther 去安装
    download() {
      let _this = this
      let systemList = _this.systemList
      for (let i = 0; i < systemList.length; i++) {
        if (_this.systemList[i].id == _this.osUrl) {
          _this.osDomain = systemList[i].url;
          window.location.href = `${_this.osDomain}/anzhuang.html`;
          return
        }
      }
    },
    // 获取系统集合
    getSystemList(params) {
      let _this = this;
      let storage = localStorage;
			let systemList = storage.getItem("systemList");
			// let switchboardIdentity = storage.getItem("switchboardIdentity");
			// console.log()
			if (systemList && systemList.length) {
				_this.systemList = JSON.parse(systemList);
      } else {
        http.get(apiData.systemList, true, {}, function (res) {
          if (res.data.code == 200 && res.data.data.list) {
            _this.systemList = res.data.data.list;
            localStorage.setItem("systemList", JSON.stringify(res.data.data.list));
          }
				});
			}
    },
    // 切换系统
    switchSystem() {
      let _this = this;
      // console.log(_this.osUrl)
      var url = "";
      for (let i = 0; i < _this.systemList.length; i++) {
        if (_this.systemList[i].id == _this.osUrl) {
          _this.osUrl = _this.systemList[i].id;
          console.log(_this.osUrl);
          // url =d
          window.location.href = apiData.tapSystem+'?businessSystemId='+_this.systemList[i].id
          break;
        }
      }
    },
  },
};
</script>
<style lang="less">
// 切换系统
.tapSystem {
  display: flex;
  align-items: center;
  justify-content: right;
  float: right;
  width: 350px;
  height: 100%;
  color: #000;
  font-size:14px;
  .title {
    margin-right: 10px;
  }
  .el-select,
  .el-input,
  .el-input__inner {
    height: 22px;
    line-height: 22px;
  }
  .el-input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input__inner {
    border-color: #999;
    color: #000;
  }
  .el-icon-arrow-up:before {
      color: #333;
  }
}
.yellow-txt {
  color: #ffba1a;
}
.commonTopbar .el-input--mini .el-input__inner {
  height: 22px !important;
  line-height: 22px !important;
  vertical-align: 1px;
}

.commonTopbar {
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  overflow: hidden;
}

.commonTopbar .bar_right .dropInfo ul li {
  float: none;
}

.commonTopbar p,
.commonTopbar span,
.commonTopbar a {
  margin: 0;
}
.commonTopbar .bar_left .download:hover {
  cursor: pointer;
  color: #23527c;
}
.commonTopbar .bar_left .download:before {
  display: inline-block;
  content: "";
  width: 11px;
  height: 20px;
  vertical-align: -5px;
  margin: 0 5px 0 20px;
  background: url(../images/watch/icon.png) no-repeat;
  background-position: -224px -62px;
}

.commonTopbar .bar_right {
  float: right;
  z-index: 303;
}

.commonTopbar .bar_right ul li {
  float: left;
}

.commonTopbar .bar_right a {
  cursor: pointer;
}

.commonTopbar .bar_right .message {
  position: relative;
  display: inline-block;
  width: 17px;
  height: 19px;
  vertical-align: -6px;
  margin-right: 10px;
  /* background: url(../images/watch/icon.png) no-repeat; */
  background-position: -240px -38px;
}

.commonTopbar .bar_right .message i {
  position: absolute;
  right: -1px;
  top: 0;
  display: inline-block;
  width: 4px;
  height: 4px;
  background: red;
  border-radius: 50%;
}
</style>